import React, { ChangeEvent } from "react";
import { Button, Container, Row, Spinner } from "react-bootstrap";
import AppTitle from "./AppTitle";

import GraphqlLogo from "../images/logo.png";
import Decoration from "../images/decoration.png";
import Logo from "../images/logo.webp";

import Styles from "../styles.module.scss";
import CharacterCard from "./CharacterCard";
import { ICharacter } from "../types";

interface IContainer {
  mode: string;
  characters: Array<ICharacter>;
  loading: boolean;
  handleChange: (e: ChangeEvent<HTMLInputElement>) => void;
  handleNext: () => void;
  filter: string;
}

export const MainContainer: React.FC<IContainer> = ({
  mode,
  filter,
  characters,
  loading,
  handleChange,
  handleNext
}) => {
  return (
    <>
      <div className='mt-5 mb-5'>
        <div className='w-100 text-center'>
          <img src={Logo} alt='Rick&Morty Logo' className='w-50' />
        </div>

        <AppTitle
          title={`Made by Valentín Galfré with Bootstrap & TypeScript ${
            mode === "GraphQL" ? "(GraphQL Version)" : "(API REST Version)"
          }`}
          link={`https://rickandmortyapi.com/${
            mode === "GraphQL" ? "graphql" : ""
          }`}
        />

        <div className='form-group w-100 justify-content-center align-items-center text-center px-5 mb-5'>
          <input
            type='email'
            className='form-control'
            placeholder='Search for something...'
            onChange={handleChange}
          />
        </div>

        <div className='px-3'>
          <p>
            Searching <b> {filter} </b>
          </p>
        </div>

        {loading ? (
          <Container className={Styles.loadingOverlay}>
            <Spinner
              animation='border'
              data-testid='loader'
              role='status'></Spinner>
          </Container>
        ) : (
          <Container>
            <Row>
              {characters &&
                characters?.length > 0 &&
                characters?.map((character: ICharacter, index: number) => (
                  <CharacterCard
                    key={index}
                    name={character.name}
                    src={character.image}
                    status={character.status}
                    gender={character.gender}
                    species={character.species}
                    location={character.location.name}
                    episode={character.episode.length}
                    origin={character.origin.name}
                    time={character.created}
                  />
                ))}
            </Row>
            {filter == "" ||
            filter == "https://rickandmortyapi.com/api/character/?name=" ? (
              <Row className='justify-content-center mt-5'>
                <Button onClick={handleNext} variant='primary'>
                  Load more
                </Button>
              </Row>
            ) : (
              ""
            )}
          </Container>
        )}

        <div className={Styles.decorationImg}>
          <a href='/developer/valentin-galfre'>
            <img
              src={mode === "GraphQL" ? GraphqlLogo : Decoration}
              alt='GraphQL Logo'
            />
          </a>
        </div>
      </div>
    </>
  );
};
